import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler, CImage } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { AppSidebarNav } from './AppSidebarNav'
import { logoNegative } from '../assets/brand/logo-negative'
import zyplelogo from './images/logo.jpg';
import zyplelogo1 from './images/Zyple Pay3.jpg';
import { sygnet } from '../assets/brand/sygnet'
import SimpleBar from 'simplebar-react'
import navigation from './_nav'
import { useState } from 'react'
import axios from 'axios'
import { Alert } from '@coreui/coreui'
import { ArrowLeftRight } from 'react-bootstrap-icons'

import Appconfig from "../APPconfig";
const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const [GetMenujson, setGetMenujson] = useState([])
  const [UniqueID, setUniqueID] = useState();
  const [formvisiable, setdformvisibale] = useState(true);
  const [nav, setnav] = useState(navigation)
  const [load, setload] = useState(true)

  var Usergrp = localStorage.getItem('ugpentry')
  var name = localStorage.getItem("user")
  if (Usergrp != null || Usergrp != 0) {
    if (name != "admin") {
      GettRights(Usergrp, 1)
   }
  }


  async function GettRights(UniqueID) {
    await axios.get(Appconfig.URL + `/usergroup/menu/${UniqueID}`, {
    }).then((response1) => {
      {
        if (response1.data.Statusflag == 'Yes') {
          var nav1 = nav
          const URL = window.location.href
          const result = URL.split('/').pop()
          const Details = response1.data.Details;
          //alert(JSON.stringify(nav1));
          try {
            nav1[0].name = localStorage.getItem('cmpname');
            for (var i = 0; i < Details.length; i++) {
              if (Details[i].PageURL.trim() == Details[i].ParentName + '/' + result) {
                if (Details[i].Select.trim() == 'N') {
                  window.location = '/404'
                }
              }
              nav1[i + 1].visible = Details[i].Select == 'Y' ? true : false

              for (var j = 0; j < Details[i].Details.length; j++) {
                if (Details[i].Details[j].PageURL.trim() == '/' + Details[i].Details[j].ParentName + '/' + result) {
                  if (Details[i].Details[j].Select.trim() == 'N') {
                    window.location = '/404'
                  }
                }
                try{
                nav1[i + 1].items[j].visible = Details[i].Details[j].Select == 'Y' ? true : false
                }
                catch{}
                //Details[i].Details[j].Select == 'Y' ? true : false
                //alert(JSON.stringify(Details[i].Details[j].Select));

                for (var r = 0; r < Details[i].Details[j].Details.length; r++) {
                  try {
                    var URL1='/'+Details[i].Details[j].Details[r].ParentName.toLowerCase()+'/' + result.toLowerCase()
                    if (Details[i].Details[j].Details[r].PageURL.trim().toLowerCase() == URL1) {
                      if (Details[i].Details[j].Details[r].Select.trim() == 'N') {
                        window.location = '/404'
                      }
                    }
                    nav1[i + 1].items[j].items[r].visible =
                      Details[i].Details[j].Details[r].Select == 'Y' ? true : false
                  } catch { }
                  for (var s = 0; s < Details[i].Details[j].Details[r].Details.length; s++) {
                    try {
                      var URL2='/'+Details[i].Details[j].Details[r].Details[s].ParentName.toLowerCase()+'/' + result.toLowerCase()
                      if (Details[i].Details[j].Details[r].Details[s].PageURL.trim().toLowerCase() == URL2) {
                        if (Details[i].Details[j].Details[r].Details[s].Select.trim() == 'N') {
                          window.location = '/404'
                        }
                      }
                      nav1[i + 1].items[j].items[r].items[s].visible =
                        Details[i].Details[j].Details[r].Details[s].Select == 'Y' ? true : false
                    } catch { } 
                  }
               
                }
                //try{
               
              // }
              // catch{}
              }
            }
          } catch (error) {
            alert(error)
          }
          setnav(nav1)
          setload(false)
        }
      }
    });
  }

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/">
        {/* <CIcon className="sidebar-brand-full" icon={logoNegative} height={35} /> */}
        <CImage className="sidebar-brand-full" src={localStorage.getItem('cmplogo') == '' ? zyplelogo : localStorage.getItem('cmplogo')} width="75%" height="75%" />
        <CImage className="sidebar-brand-narrow" src={localStorage.getItem('cmplogo') == '' ? zyplelogo : localStorage.getItem('cmplogo')} width="75%" height="75%" />
        {/* <CIcon className="sidebar-brand-narrow" icon={sygnet} height={35} /> */}
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={nav} />
        </SimpleBar>
      </CSidebarNav>
      <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
      />
    </CSidebar>
  )
}

export default AppSidebar
// export default React.memo(AppSidebar)
